import { render } from "./DevicesInventoryComponent.vue?vue&type=template&id=68156bc2&scoped=true"
import script from "./DevicesInventoryComponent.vue?vue&type=script&lang=js"
export * from "./DevicesInventoryComponent.vue?vue&type=script&lang=js"

import "./DevicesInventoryComponent.vue?vue&type=style&index=0&id=68156bc2&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68156bc2"]])

export default __exports__